export type PromiseCallback = (
  res: (bool: boolean) => void,
  instigator?: unknown,
  target?: unknown,
) => unknown;

interface PromiseData {
  promise: PromiseCallback; // Content of the promise
  instigator: unknown; // Who triggered this promise
  target?: unknown; // Who is the target of this promise
}

export class PromiseManager {
  private promises: PromiseData[] = [];
  public get anyPromise(): boolean {
    return this.promises.length > 0;
  }

  public AddPromise(
    promise: PromiseCallback,
    instigator?: unknown,
    target?: unknown,
  ): void {
    this.promises.push({ promise, instigator, target });
  }

  public RunPromises(): Promise<unknown> {
    return new Promise((resolve) => {
      const promiseData = this.promises.shift();
      if (!promiseData) return resolve(true);

      new Promise((res) => {
        return promiseData.promise(
          res,
          promiseData.instigator,
          promiseData.target,
        );
      }).then(() => {
        return resolve(this.RunPromises());
      });
    });
  }

  public ClearPromises(): void {
    this.promises = [];
  }
}
